import { memo } from "react";
import { Col, Row } from "react-bootstrap";
import PhaseCount from "Components/Pages/Dashboard/PhaseCount";
import PhasePatientList from "Components/Pages/Dashboard/PhasePatientList";

const PhaseCountWithPatientList = () => {
  return (
    <div className="border-0 p-0 patient_phase_card">
      <PhaseCount />

      <div className="home_list_area">
        <Row className="m-0">
          <Col className="patient_list">
            <PhasePatientList />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default memo(PhaseCountWithPatientList);
